import { produce } from 'immer';

import { UploadInternalBannerImage } from '../../../actions/imageEditor/internal/uploadInternalBannerImage';
import { getImageEditorIdByBannerId } from '../../../service/ImageHelpers/ImageHelpers';
import { getUploadingImagesHash } from '../../../service/ImageHelpers/ImageHelpers';
import { ImageOrCreativeUploadingMode } from '../../../typings/banners';
import { ImageEditorsState } from '../../../typings/state';

export function uploadInternalBannerImage(
    state: ImageEditorsState,
    action: UploadInternalBannerImage
): ImageEditorsState {
    const { UPLOADING, UPLOADING_LOCAL } = ImageOrCreativeUploadingMode;
    const id = getImageEditorIdByBannerId(action.bannerId, action.resourceId);

    return produce(state, draft => {
        draft[id].image.mode = action.isLocalUploading ? UPLOADING_LOCAL : UPLOADING;
        draft[id].image.isUploadByLink = false;
        draft[id].image.uploadingData = getUploadingImagesHash(action.filesToUpload);
        draft[id].image.errors = undefined;
    });
}
